import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Inkflow from "@/components/Inkflow";
import PrivacyPolicy from "@/components/PrivacyPolicy";
import Terms from "@/components/Terms";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Inkflow />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
